import React from 'react';
import { Shield } from 'lucide-react';
import Layout from '../components/Layout';

const PrivacyPage = () => {
  return (
    <Layout>
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center space-x-3 mb-8">
          <Shield className="w-8 h-8 text-blue-600" />
          <h1 className="text-3xl font-bold">Политика конфиденциальности</h1>
        </div>

        <div className="prose prose-blue max-w-none">
          <p className="text-lg text-gray-600 mb-6">
            Последнее обновление: 19 декабря 2024 г.
          </p>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">1. Общие положения</h2>
            <p className="text-gray-600 mb-4">
              ИП Платов Олег Сергеевич (далее - "Исполнитель") обязуется защищать и уважать вашу конфиденциальность. Данная политика конфиденциальности описывает, как мы собираем и используем персональные данные, полученные от вас при использовании наших услуг фото- и видеосъёмки.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">2. Сбор и использование персональных данных</h2>
            <p className="text-gray-600 mb-4">
              При заказе наших услуг мы собираем следующую информацию:
            </p>
            <ul className="list-disc list-inside text-gray-600 mb-4">
              <li>Контактные данные (имя, email, телефон) - для связи с вами по вопросам заказа</li>
              <li>Платёжную информацию - для обработки оплаты услуг</li>
              <li>Информацию о мероприятии или проекте - для подготовки к съёмке</li>
            </ul>
            <p className="text-gray-600 mb-4">
              Мы используем эту информацию исключительно для:
            </p>
            <ul className="list-disc list-inside text-gray-600 mb-4">
              <li>Оказания заказанных вами услуг</li>
              <li>Обработки ваших платежей</li>
              <li>Коммуникации с вами по вопросам заказа</li>
              <li>Информирования вас о статусе работ</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">3. Хранение и защита данных</h2>
            <p className="text-gray-600 mb-4">
              Мы храним ваши персональные данные только в течение срока, необходимого для оказания услуг и выполнения наших обязательств. Мы принимаем необходимые меры для защиты ваших данных от несанкционированного доступа.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">4. Фото и видео материалы</h2>
            <p className="text-gray-600 mb-4">
              Все фото и видео материалы, созданные в процессе оказания услуг:
            </p>
            <ul className="list-disc list-inside text-gray-600 mb-4">
              <li>Передаются исключительно заказчику</li>
              <li>Могут быть использованы в портфолио исполнителя только с вашего согласия</li>
              <li>Хранятся в защищённом архиве в течение 30 дней после передачи заказчику</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">5. Ваши права</h2>
            <p className="text-gray-600 mb-4">
              Вы имеете право:
            </p>
            <ul className="list-disc list-inside text-gray-600 mb-4">
              <li>Получить информацию о ваших персональных данных, которые мы храним</li>
              <li>Требовать исправления неточных данных</li>
              <li>Требовать удаления ваших данных</li>
              <li>Отозвать согласие на использование ваших материалов в портфолио</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">6. Контакты</h2>
            <p className="text-gray-600 mb-4">
              По всем вопросам, связанным с обработкой персональных данных, вы можете связаться с нами по email: Oleg.platov.04@mail.ru
            </p>
          </section>
        </div>
      </div>
    </Layout>
  );
};

export default PrivacyPage;